import React, { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import './FallBackComponent.scss';

interface FallbackComponentProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const FallbackComponent: React.FC<FallbackComponentProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div className="error-container">
      <h2 className="error-title">Something went wrong!</h2>
      <p className="error-message">{error.message}</p>
      <button className="retry-button" onClick={resetErrorBoundary}>Try Again</button>
    </div>
  );
};


interface MyErrorBoundaryProps {
  children: ReactNode; 
}

const MyErrorBoundary: React.FC<MyErrorBoundaryProps> = ({ children }) => {
  return (
    <ErrorBoundary
      FallbackComponent={FallbackComponent}
      onReset={() => {
      }}
    >
      {children}
    </ErrorBoundary>
  );
};

export default MyErrorBoundary;
